var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":_vm.Integration}},[_vm._v("积分兑换")]),_c('button',{on:{"click":_vm.Policy}},[_vm._v("隐私政策")]),_c('button',{on:{"click":_vm.Ins}},[_vm._v("常见问题")]),_c('button',{on:{"click":_vm.Protocol}},[_vm._v("用户协议")])])}
var staticRenderFns = []

export { render, staticRenderFns }